import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import MindsetsJsSDK, {accessConstants, authUtils, LoadPracticesAction} from 'mindsets-js-sdk';
import NoAccess from "../../common/NoAccess";
import {Link, redirect} from "react-router-dom";

export default function () {
    const dispatch = useDispatch();
    const me = useSelector(state => state.me);
    const practices = useSelector(state => state.practices);
    const [items, setItems] = useState([]);

    useEffect(() => {
        dispatch(LoadPracticesAction());
        MindsetsJsSDK().API.get('question_practice_skills/overview').then((response) => {
            setItems(response.items);
        })
    }, []);

    if (!me) {
        return null;
    }
    if (authUtils.iCant(me, [accessConstants.PERMISSION_CAN_SEE_RUBRICS])) {
        return (
            <NoAccess/>
        );
    }

    if (!practices.length || !items.length) {
        return null;
    }

    let exist = 0;
    const total = items.length * practices.length;
    items.map((item) => {
        exist += item.practices.length;
    });

    return (
        <div className='container'>
            <h1>Rubric Overview</h1>
            <div className="table-responsive">
                <div className='my-2'>Summary: {exist} rubrics exist out of {total} possible combinations</div>
                <table className="table table-bordered table-hover">
                    <thead>
                    <tr className="text-center">
                        <th scope="col">&nbsp;</th>
                        {practices.map(practice => <th key={practice.code}>{practice.code}</th>)}
                    </tr>
                    </thead>
                    <tbody>
                    {items.sort((a, b) => {
                        if (a.name < b.name) {
                            return -1;
                        }
                        if (a.name > b.name) {
                            return 1;
                        }

                        return 0;
                    }).map((item, index) => {
                        return (
                            <tr key={index}>
                                <th>{item.name}{item.measure ? '(' + item.measure + ')' : ''}</th>
                                {practices.map(practice => {
                                    return (
                                        <td key={practice.code + '-' + index} className='paddingless'>
                                            <Link
                                                to={`/rubrics/${item.code}?practice_id=${practice.id}`}
                                                className="text-center hoverable clickable d-flex h-100 align-items-center justify-content-center"
                                            >
                                                <i className={'fas fa-' + (item.practices.includes(practice.id) ? 'check text-success' : 'times red')}/>
                                            </Link>
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
